const LOCAL_HOST_SUFFIXES = ['.local', '.internal'];

const PRIVATE_IPV4 =
  /^(?:10|127)\.|^169\.254\.|^192\.168\.|^172\.(?:1[6-9]|2[0-9]|3[01])\.|^100\.(?:6[4-9]|[7-9][0-9]|1[01][0-9]|12[0-7])\./;

/** Unique-local (fc00::/7) and link-local (fe80::/10), as URL bracket hosts. */
const PRIVATE_IPV6 = /^\[(?:f[cd][0-9a-f]{2}|fe[89ab][0-9a-f]):/;

export const isLocalNetworkUrl = (source: string): boolean => {
  let hostname: string;
  try {
    hostname = new URL(source).hostname.toLowerCase();
  } catch {
    return false;
  }

  if (hostname === 'localhost' || hostname === '[::1]') {
    return true;
  }

  if (LOCAL_HOST_SUFFIXES.some(suffix => hostname.endsWith(suffix))) {
    return true;
  }

  return PRIVATE_IPV4.test(hostname) || PRIVATE_IPV6.test(hostname);
};
